import { Box, Typography, Button } from '@mui/material'
import { Navbar } from '../../components/Navbar'
import { Footer } from '../../components/Footer'
import { PageContainer } from '../../components/styled/PageContainer'
import { StoreTable } from './StoreTable'
import { StoreFilter } from './StoreFilter'
import { Location } from './Location'

export const StoreLocator = () => {
  return (
    <Box>
      <Navbar />
      <PageContainer>
        <Box width='100%' height={{ xs: 650, sm: 900, md: 650 }}>
          <Location />
        </Box>
        {/* <Box display='flex' mt={5} justifyContent='center'>
          <Typography variant='h1' style={{ fontWeight: 'bold', fontSize: '32px' }}>
            Nexen Center
          </Typography>
        </Box>
        <StoreFilter />
        <StoreTable /> */}
      </PageContainer>
      <Footer />
    </Box>
  )
}
